import { Grid } from '@mui/material';

const { TextInput, Autosuggest } = require('components');

const AcademyForm = ({ academy, handleChange, partners }) => {
	return (
		<Grid container spacing={1}>
			<Grid item xs={12} sm={12}>
				<TextInput
					value={academy.title}
					label="Title"
					name="title"
					placeholder="Title"
					required
					handleChange={handleChange}
				/>
			</Grid>
			<Grid item xs={12} sm={12}>
				<TextInput
					rows={3}
					multiline
					value={academy.description}
					label="Description"
					name="description"
					placeholder="Description"
					handleChange={handleChange}
				/>
			</Grid>
			<Grid item xs={12} sm={12}>
				<Autosuggest
					options={
						partners?.map((item) => ({
							label: item.name,
							value: item.id
						})) ?? []
					}
					value={academy.partner_id}
					label="Partner"
					name="partner_id"
					placeholder=""
					handleChange={handleChange}
				/>
			</Grid>
		</Grid>
	);
};

export default AcademyForm;
